import React, { useEffect, useMemo, useState } from "react";
import { I } from "../data";
import { useWorkspace } from "../WorkspaceContext";

export default function CmdPalette({ open, onClose, go }) {
  const { universities } = useWorkspace();
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(0);

  const items = useMemo(() => {
    const pages = [
      { id: "p-chat", label: "Open AI Advisor", icon: "Chat", action: () => go("chat"), kbd: "G C" },
      { id: "p-dash", label: "Go to Dashboard", icon: "Home", action: () => go("dashboard"), kbd: "G D" },
      { id: "p-board", label: "Open Application Board", icon: "Board", action: () => go("board"), kbd: "G B" },
      { id: "p-tasks", label: "Open Task Center", icon: "Check", action: () => go("tasks"), kbd: "G T" },
      { id: "p-schol", label: "Open Scholarships", icon: "Trophy", action: () => go("scholarships"), kbd: "G S" },
    ];
    const unis = universities.map((u) => ({
      id: `u-${u.id}`, label: u.name, icon: "GraduationCap",
      action: () => go("detail", u.id), kbd: "Open detail",
    }));
    const actions = [
      { id: "a-add", label: "Add a university to my shortlist", icon: "Plus", action: () => go("board"), kbd: "+ U" },
      { id: "a-task", label: "Create a new task", icon: "Check", action: () => go("tasks"), kbd: "+ T" },
      { id: "a-ask", label: "Ask the AI advisor", icon: "Sparkle", action: () => go("chat"), kbd: "?" },
    ];
    const all = [
      { section: "Pages", items: pages },
      { section: "Universities", items: unis },
      { section: "Actions", items: actions },
    ];
    if (!q) return all;
    return all
      .map((s) => ({ ...s, items: s.items.filter((i) => i.label.toLowerCase().includes(q.toLowerCase())) }))
      .filter((s) => s.items.length > 0);
  }, [q, universities, go]);

  const flat = items.flatMap((s) => s.items);

  useEffect(() => { setSel(0); }, [q]);

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") onClose();
      if (e.key === "ArrowDown") { e.preventDefault(); setSel((s) => Math.min(s + 1, flat.length - 1)); }
      if (e.key === "ArrowUp") { e.preventDefault(); setSel((s) => Math.max(s - 1, 0)); }
      if (e.key === "Enter" && flat[sel]) { flat[sel].action(); onClose(); }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, flat, sel, onClose]);

  if (!open) return null;
  let idx = 0;
  return (
    <div className="cmd-overlay" onClick={onClose} data-testid="cmd-palette">
      <div className="cmd-modal" onClick={(e) => e.stopPropagation()}>
        <div className="cmd-input-wrap">
          <I.Search size={16} />
          <input
            className="cmd-input"
            placeholder="Search universities, jump to a page, or run a command…"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            autoFocus
            data-testid="cmd-input"
          />
          <kbd style={{ fontFamily: "var(--font-mono)", fontSize: 11, background: "var(--bg)", border: "1px solid var(--ink-5)", padding: "1px 6px", borderRadius: 4, color: "var(--ink-3)" }}>esc</kbd>
        </div>
        <div className="cmd-list">
          {items.map((s) => (
            <div key={s.section}>
              <div className="cmd-section-h">{s.section}</div>
              {s.items.map((it) => {
                const myIdx = idx++;
                const Icon = I[it.icon];
                return (
                  <div
                    key={it.id}
                    className={`cmd-item ${sel === myIdx ? "selected" : ""}`}
                    onMouseEnter={() => setSel(myIdx)}
                    onClick={() => { it.action(); onClose(); }}
                    data-testid={`cmd-${it.id}`}
                  >
                    <span className="cmd-item-icon"><Icon size={15} /></span>
                    <span>{it.label}</span>
                    <span className="cmd-item-meta">{it.kbd}</span>
                  </div>
                );
              })}
            </div>
          ))}
          {flat.length === 0 && (
            <div style={{ padding: 24, textAlign: "center", color: "var(--ink-4)", fontSize: 13 }}>
              No matches for "{q}"
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
